export default __webpack_public_path__ + "data/00dd1e9.japan.prefectures.geo.json";